<template>
    <div class="reportTeacher margin-top">
        <div class="layout-box-white-bg-ig6pe">
            <div class="simple-2S7p1">
                <span class="title">教师德育报告</span>
                <p class="update-time">报告数据每天早上9点左右更新</p>
            </div>
            <div class="filter-panel">

                <div class="item">
                    <span class="label">周期：</span>
                    <el-select v-model="timeId" placeholder="全部" @change="getSelectTime">
                        <el-option
                                v-for="item in timeList"
                                :key="item.timeScope"
                                :label="item.text"
                                :value="item.timeScope">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <section class="custom-caption">
                <span class="title">教师查看情况</span>
                <el-popover
                        placement="right"
                        width="400"
                        trigger="click">
                    <div style="color: #0D0D0D;" class="border-bottom padding-y">
                        说明
                    </div>
                    <p>
                        师训课程看课时长：教师观看德育师训课实际观看时长总和
                    </p>
                    <p>
                        师训课程看课节数：教师观看完成的德育中心师训课程看课节数总和，课程包括生涯教育培训、心理健康教育培训和师风师德建设
                    </p>
                    <p>
                        班会课下载次数：教师下载班会课PPT和教案的下载次数总和
                    </p>
                    <p>
                        问题指导手册浏览次数：教师浏览问题指导手册内学生问题标题次数总和
                    </p>
                    <i slot="reference" class="el-icon-warning-outline"></i>
                </el-popover>
            </section>
            <div class="custom-table">
                <el-table
                        :data="tableData"
                        border
                        :header-cell-style="{
                                        'background-color': '#f5f8ff',
                                        'color': '#000',
                                        'font-weight': '400'
                                    }"
                        style="width: 100%">
                    <el-table-column
                            prop="teacherName"
                            label="教师姓名(前十名)"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="classTime"
                            label="师训课程看课节数"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="sectionNum"
                            label="师训课程看课时长（分）">
                    </el-table-column>
                    <el-table-column
                            prop="cmDonwloads"
                            label="班会课下载次数">
                    </el-table-column>
                     <el-table-column
                            prop="stuProblemViews"
                            label="问题指导手册浏览次数">
                    </el-table-column>
<!--                     <el-table-column-->
<!--                            prop="teacherName"-->
<!--                            label="问题指导手册浏览次数">-->
<!--                    </el-table-column>-->
                </el-table>
            </div>
            <section class="custom-caption">
                <span class="title">德育资源排行榜</span>
                <el-popover placement="right" width="400" trigger="click">
                    <p>
                        近1个月看课教师数：全校教师观看的视频课程中，某课程近1个月观看的家长数
                    </p>
                    <p>
                        累计看课教师数：全校教师观看的视频课程中，某课程累计观看的家长数
                    </p>
                    <i slot="reference" class="el-icon-warning-outline"></i>
                </el-popover>
            </section>
            <div class="margin-medium-top">
                <span class="text-medium-secondary">资源类型：</span>
                <el-button v-for="item in typeList" type="text" :key="item.resourceType"
                           :class="typeId===item.resourceType?'active':''"
                           size="mini" style="padding: 5px 10px;" class="margin-left"
                        @click="selectZyData(item.resourceType,item.text)">
                    {{item.text}}
                </el-button>
            </div>
            <div class="margin-top numberColor">
                {{typeName}}浏览次数前10名
            </div>
            <!--展示进度-->
            <div class="margin-top">
                <div class="">
                    <div v-for="(item,index) in zyDataList"
                         class="margin-bottom"
                         :key="index">
                        <div>
                            {{item.resourceName}}
                        </div>
                        <el-progress v-if="parseInt(item.times)" :percentage="item.num" :show-text="false" >
                        </el-progress>
                        <div>
                            {{item.times}}次数
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        moralEduLogResourceType,
        moralEduLogTimeScope,
        teacherGrades
    } from '../../../config/index'
    import {moralEduLogItemTable, moralEduLogResourceRank} from "../../../config";
    export default {
        name: "reportTeacher",
        data(){
            return{
                value: '',
                Grade:[],
                timeId:'',
                timeList:[],
                tableData:[],
                typeList:[],
                typeId:'',
                typeName:'',
                zyDataList:[],
                currentPage:1,
                totalItem:0
            }
        },
        mounted(){
          this.timeCycle();
          this.searchType();
        },
        methods:{
            selectZyData(val,name){
                this.typeId=val;
                this.typeName=name;
                this.zyData();
            },
            getSelectTime(){
                this.searchTableQk();
            },
            async searchTableQk(){
                let result=await moralEduLogItemTable(this.timeId);
                if(result.status){
                    this.tableData=result.data.tableItems;
                }
            },
            //查出周期
            async timeCycle(){
               let result=await moralEduLogTimeScope();
               if(result.status){
                   this.timeList=result.data;
                   this.timeId=result.data[0].timeScope;
                   this.searchTableQk();
               }
            },
            //查出资源类型
            async searchType(){
                let result=await moralEduLogResourceType();
                if(result.status){
                    this.typeList=result.data;
                    this.typeId=result.data[0].resourceType;
                    this.typeName=result.data[0].text;
                    this.zyData();
                }
            },
            //根据资源类型查出资源数据
            async zyData(){
              let result=await moralEduLogResourceRank(this.typeId);
              if(result.status){
                  this.zyDataList=result.data;
                  this.zyDataList[0].num=90;
                  this.zyDataList[1].num=85;
                  this.zyDataList[2].num=80;
                  this.zyDataList[3].num=70;
                  this.zyDataList[4].num=65;
                  this.zyDataList[5].num=55;
                  this.zyDataList[6].num=45;
                  this.zyDataList[7].num=35;
                  this.zyDataList[8].num=30;
                  this.zyDataList[9].num=20;
                  console.log(result.data);
              }
            },
            async getTeacherGrades(){
                let res = await teacherGrades();
                if (res.status){
                    this.Grade = res.data.tableItems;
                }
            },
            getSelectOne(val){
                console.log(val);
            }
        },
        created() {
            this.getTeacherGrades();
        }
    }
</script>

<style scoped lang="scss">
.reportTeacher{
    .layout-box-white-bg-ig6pe{
        background-color: #fff;
        padding: 0 32px 32px 32px;
        .simple-2S7p1{
            border-bottom: 1px solid #E6EAF5;
            font-size: 18px;
            padding: 22px 0;
            color: #373a44;
            position: relative;
            margin-bottom: 16px;
            .update-time {
                font-size: 14px;
                color: #FF9631;
                margin-left: 13px;
                display: inline-block;
            }
        }
        .filter-panel{

            font-size: 14px;
            color: #7c89a7;
            padding: 8px 0 24px;
            .item{
                margin-right: 24px;
                display: inline-block;
            }
        }
        .custom-caption {
            font-size: 18px;
            height: 32px;
            color: #373a44;
            position: relative;
            margin-bottom: 16px;
            .title {
                font-weight: 600;
                line-height: 32px;
                padding-left: 12px;
                border-left: 3px solid #1A83FF;
            }
        }
        .custom-table{
            margin-bottom: 30px;
        }
    }
}
</style>
